import { toast } from 'react-toastify'

function errorToaster(msg, autoClose = 5000){
  toast.error(msg, {
    autoClose: autoClose,
    closeButton: !autoClose,
    className: 'toast-inner-container toast-error',
    bodyClassName: 'toast-body'
  })
}

function infoToaster(msg, autoClose = 5000){
  toast.info(msg, {
    autoClose: autoClose,
    closeButton: !autoClose,
    hideProgressBar: true,
    className: 'toast-inner-container toast-info',
    bodyClassName: 'toast-body'
  })
}

function warnToaster(msg, autoClose = 5000) {
  toast.warn(msg, {
    autoClose: autoClose,
    closeButton: !autoClose,
    className: 'toast-inner-container toast-warn',
    bodyClassName: 'toast-body'
  })
}

export {
  errorToaster,
  warnToaster,
  infoToaster
}